import React from "react";
import PropTypes from "prop-types";
import "./style.scss";
import { RichText } from "@learningblocks/shared-components/lib/RichText";
import { injectIntl, FormattedMessage } from "react-intl";

class DidYouKnowComponent extends React.Component {
  render() {
    const { intl } = this.props;

    return (
      <div className="didyouknow">
        <div className="didyouknow__heading__wrapper">
          {this.props.image && (
            <img
              src={this.props.image.src}
              alt={intl.formatMessage({
                id: this.props.image ? this.props.image.alt : "",
                defaultMessage: this.props.image ? this.props.image.alt : "",
                description: "",
              })}
            />
          )}
          <div className="didyouknow_heading__wrapper--container">
            <h5>
              <FormattedMessage
                id={this.props.heading}
                defaultMessage={this.props.heading}
                description=""
              />
            </h5>
          </div>
        </div>
        <div className="didyouknow__content--container">
          <p>
            <RichText text={this.props.content} />
          </p>
        </div>
      </div>
    );
  }
}

DidYouKnowComponent.propTypes = {
  image: PropTypes.string,
  heading: PropTypes.string,
  content: PropTypes.string,
  className: PropTypes.string,
};

DidYouKnowComponent.defaultProps = {
  className: "didyouknow",
};

export const DidYouKnow = injectIntl(DidYouKnowComponent);
